// 主人公の連撃 (3段・描いたコマ・攻撃中の押しを覚える) を出すかの切り替え。
//   2026-10-02 ユーザー「配布版はひとまず変更前よりも前のSpineで1パターンの攻撃しかしていない状態に戻しておいて」
//   10-02 夜 ユーザー「3段は配布版で一旦有効にしていい」= 既定は入 (骨の attack_1/2/3・速さ B)。
//   旧の1段 (Spine の attack・押しは idle でだけ受ける) は開発中だけ URL に ?comboTrial=0 で見比べる (main.ts の DEV 箱)。
let enabled = true

export function playerComboEnabled(): boolean {
  return enabled
}

export function setPlayerComboEnabled(on: boolean): void {
  enabled = on
}
